import type { profile as en } from '@/i18n/locales/en/profile';
import type { Translation } from '@/i18n/types';

export const profile: Translation<typeof en> = {
  title: 'Perfil',
  lead: 'O teu nome, idioma e definições de privacidade.',
  pendingBadge: '{{count}} pedido de consentimento pendente',
  nav: {
    label: 'Menu do perfil',
    profile: 'Perfil',
    consents: 'Consentimentos',
    preferences: 'Preferências',
    subscription: 'Subscrição',
  },
  preferredLanguage: 'Idioma preferido',
  preferredLanguageOptional: 'Idioma preferido (opcional)',
  preferredLanguageUnset: 'Não definido',
  timezoneUnset: 'Predefinição da implementação',
  saved: 'Guardado.',
  save: 'Guardar',
  privateFieldsHint:
    'Estes quatro campos são privados — só tu podes vê-los ou alterá-los, seja quem for que possa ver o resto do teu registo.',
  details: {
    title: 'Dados',
    rolesTitle: 'Funções',
  },
  regionAndTimezone: {
    title: 'Região e fuso horário',
  },
  fields: {
    name: 'Nome',
    email: 'E-mail',
    nickname: 'Alcunha',
    region: 'Região',
    regionUnset: 'Não definido',
    regionHint: 'O país para o qual as tuas estatísticas/relatórios são localizados.',
    timezone: 'Fuso horário para estatísticas',
    timezoneHint: 'O calendário com que os teus dias de estatísticas são fechados.',
    gender: 'Género',
    birthdate: 'Data de nascimento',
    height: 'Altura (cm)',
    weight: 'Peso (kg)',
  },
};
